export default "__VITE_ASSET__S72u4Dy1__"